var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "large-12" }, [
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-12 columns" }, [
        _c("h3", [_vm._v("Stichtag")]),
        _vm._v(" "),
        !_vm.showStyle
          ? _c(
              "div",
              { staticClass: "spv-select-group flex-no-wrap row" },
              _vm._l(_vm.deadlines, function(d) {
                return _c(
                  "div",
                  { key: d.id, class: "small-6 medium-4 large-4 columns" },
                  [
                    _c("div", { staticClass: "radio-input" }, [
                      _c("input", {
                        attrs: {
                          id: "climate-" + d.id,
                          type: "radio",
                          name: "climate-deadline"
                        },
                        domProps: {
                          checked: _vm.deadline_id == d.id,
                          value: d.id
                        },
                        on: {
                          change: function($event) {
                            _vm.onSelectDeadline(d.id)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          class: { checked: _vm.deadline_id == d.id },
                          attrs: { for: "climate-" + d.id }
                        },
                        [_c("p", [_vm._v(_vm._s(d.name))])]
                      )
                    ])
                  ]
                )
              })
            )
          : _c("div", { staticClass: "spv-select-group" }, [
              _c("div", { staticClass: "small-12 medium-6 large-4" }, [
                _c(
                  "select",
                  {
                    staticClass: "spv-input-select",
                    domProps: { value: _vm.deadline_id },
                    on: {
                      change: function(e) {
                        return _vm.onSelectDeadline(e.target.value)
                      }
                    }
                  },
                  _vm._l(_vm.deadlines, function(d) {
                    return _c(
                      "option",
                      { key: d.id, domProps: { value: d.id } },
                      [
                        _vm._v(
                          "\n              " + _vm._s(d.name) + "\n            "
                        )
                      ]
                    )
                  })
                )
              ])
            ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-6 columns" }, [
        _c("h3", [_vm._v("Zeitraum")]),
        _vm._v(" "),
        _c("div", { staticClass: "large-8" }, [
          _c(
            "select",
            {
              staticClass: "spv-input-select",
              domProps: { value: _vm.year_ },
              on: {
                change: function(e) {
                  return _vm.onSelectYear(e.target.value)
                }
              }
            },
            _vm._l(_vm.years, function(y) {
              return _c("option", { key: y, domProps: { value: y } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.deadline_id === "j"
                        ? "Jun " + y + " - Mai " + (y + 1)
                        : "Dez " + y + " - Nov " + (y + 1)
                    ) +
                    "\n          "
                )
              ])
            })
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-12 columns" }, [
        _c("h1", [
          _vm._v(
            "Normierte Wertentwicklung Climate Objective Index " +
              _vm._s(_vm.deadline_.name)
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "large-12 columns spv-chart-wrapper" },
          [
            _c("index-chart", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.deadline_id === "j",
                  expression: "deadline_id === 'j'"
                }
              ],
              attrs: {
                data: _vm.chart_items["j"] || [],
                max: _vm.chart_max["j"] || 0,
                name: "Climate Objective Index",
                color: "#E81700"
              }
            }),
            _vm._v(" "),
            _c("index-chart", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.deadline_id === "d",
                  expression: "deadline_id === 'd'"
                }
              ],
              attrs: {
                data: _vm.chart_items["d"] || [],
                max: _vm.chart_max["d"] || 0,
                name: "Climate Objective Index",
                color: "#E81700"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "spv-price-inquiry" }, [
              _c("b", { staticClass: "spv-price-inquiry__label" }, [
                _vm._v("Kursabfrage")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "spv-price-inquiry__date-picker" },
                [
                  _c("span", [_vm._v("Datum")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: {
                      min: _vm.min_date,
                      max: _vm.max_date,
                      value: _vm.inquiry_date
                    },
                    on: { select: _vm.onSelectInquiryDate }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "spv-price-inquiry__value" }, [
                !_vm.inquiry_valid && !_vm.inquiry_date
                  ? _c("span", { staticClass: "error-value" }, [
                      _vm._v(
                        "\n              Bitte wählen Sie ein Datum\n            "
                      )
                    ])
                  : _vm.inquiry_value === -1
                    ? _c("span", { staticClass: "error-value" }, [
                        _vm._v(
                          "\n              Für dieses Datum liegt kein Datensatz vor. Bitte wählen Sie ein anderes Datum aus\n            "
                        )
                      ])
                    : !!_vm.inquiry_value
                      ? _c("span", [
                          _vm._v("\n              Climate Objective Index  "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.inquiry_value) + " Punkte")
                          ])
                        ])
                      : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button button-small block",
                  on: { click: _vm.loadDayValue }
                },
                [_vm._v("Anzeigen")]
              )
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm.configText
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.configText) } })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_data
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _vm.details_data.index_values && _vm.details_data.index_values.length
            ? _c("div", { staticClass: "medium-12 large-12 columns" }, [
                _c("h1", [
                  _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
                    _vm._v("\n          Monatliche\n          "),
                    _c("div", { staticClass: "info-overlay" }, [
                      _vm._v("\n            Wertentwicklung\n            "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-overlay__text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.gloss_texts_trend[0]) +
                            "\n            "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spv-info-wrapper text-only" }, [
                    _vm._v(
                      "\n          Climate Objective Index " +
                        _vm._s(_vm.deadline_.name) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
                    _c("span", { staticClass: "text-normal" }, [
                      _vm._v("mit Zielvolatilität")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-overlay" }, [
                      _c("span", { staticClass: "text-normal" }, [
                        _vm._v(_vm._s(_vm.targetVol))
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-overlay__text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.gloss_texts_trend[1]) +
                            "\n            "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "spv-table-wrapper" }, [
                  _c(
                    "table",
                    { staticClass: "spv-product-table spv-index-table" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "medium-8 large-9" }, [
                            _vm._v("\n                Indexstichtag"),
                            _c("br"),
                            _vm._v(
                              _vm._s(_vm.deadline_.label) +
                                _vm._s(_vm.details_data.year) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(2)
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.details_data.index_values, function(
                          data,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _vm._v(_vm._s(_vm.formatDate(data.date)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.formatMoney(data.index_value, 2))
                              )
                            ])
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("tfoot", [
                        _c("tr", [
                          _c("td", { staticClass: "td-padding" }, [
                            _c("div", { staticClass: "spv-info-wrapper" }, [
                              _vm._v(
                                "\n                  Jahresrendite\n                  "
                              ),
                              _c("div", { staticClass: "info-overlay" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-overlay__text right-auto"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.gloss_texts_trend[3]) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatPercent(
                                  _vm.details_data.yearly_yield,
                                  2
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [
                            _c("div", { staticClass: "spv-info-wrapper" }, [
                              _vm._v(
                                "\n                  Maßgebliche\n                  "
                              ),
                              _c("div", { staticClass: "info-overlay" }, [
                                _vm._v(
                                  "\n                    Jahresrendite\n                    "
                                ),
                                _vm._m(4),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-overlay__text right-auto"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.gloss_texts_trend[4]) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatPercent(
                                  _vm.details_data.decisive_yearly_yield,
                                  2
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pdf-button-wrapper" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button button-small",
                      on: { click: _vm.onCreatePdf }
                    },
                    [_vm._v("\n          Drucken\n        ")]
                  )
                ])
              ])
            : _c("div", { staticClass: "medium-12 large-12 columns" }, [
                _c("h1", { staticClass: "no-margin" }, [
                  _vm._v(
                    "Keine Monatswerte für Climate Objective Index für " +
                      _vm._s(_vm.deadline_.name) +
                      " vorhanden."
                  )
                ])
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-12 columns" }, [
        _c("h1", [
          _vm._v(
            "Zusammensetzung der Aktien des Climate Objective Index " +
              _vm._s(_vm.deadline_.name)
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [
            _vm._v(
              "Stand " + _vm._s(_vm.assets_month_name + " " + _vm.assets_year)
            )
          ])
        ]),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.configTextOfAsset) } })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-12 medium-12 large-12 columns chart-spacing" },
        [
          _c("n-accordion-chart", {
            attrs: { items: _vm.accordion_chart_items }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.configText60
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("br"),
            _vm._v(" "),
            _c("h2", [_vm._v("Details zum Indexportfolio")]),
            _vm._v(" "),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.configText60) } })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "small-12 medium-12 large-12 columns" }, [
        _c("div", { staticClass: "spv-table-wrapper" }, [
          _c("input", {
            class: "climate-asset-filter",
            attrs: {
              type: "text",
              placeholder: "Suche nach Name, Land oder Industrie"
            },
            domProps: { value: _vm.asset_filter },
            on: {
              input: function(e) {
                return (_vm.asset_filter = e.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "table",
            {
              staticClass:
                "spv-product-table spv-index-table spv-index-table--climate"
            },
            [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.assets_, function(asset, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(asset.name))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(asset.country))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(asset.industry))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.formatPercent(asset.weight, 2)))
                    ])
                  ])
                })
              )
            ]
          ),
          _vm._v(" "),
          _vm.assets.length > 10
            ? _c("div", { staticClass: "text-center" }, [
                !_vm.asset_filter
                  ? _c(
                      "a",
                      {
                        staticClass: "toggle-expand",
                        on: {
                          click: function($event) {
                            _vm.show_all_rows = !_vm.show_all_rows
                          }
                        }
                      },
                      [
                        !_vm.show_all_rows
                          ? _c("i", { staticClass: "fo fo-arrow-down" })
                          : _c("i", { staticClass: "fo fo-arrow-up" })
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.factsheet_path && _vm.factsheet_path[_vm.deadline_id]
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "button call-to-action",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.onOpenFactsheet(
                        _vm.factsheet_path[_vm.deadline_id + "_path"]
                      )
                    }
                  }
                },
                [_vm._v("\n          Download Factsheet\n        ")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "medium-4 large-3" }, [
      _vm._v("\n                Indexstand"),
      _c("br"),
      _vm._v("jeweils am"),
      _c("br"),
      _vm._v("Ende des Monats\n              ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Land")]),
        _vm._v(" "),
        _c("th", [_vm._v("Industrie")]),
        _vm._v(" "),
        _c("th", [_vm._v("Gewichtung")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a54ac1e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a54ac1e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/spv_climate.vue
// module id = 0wBF
// module chunks = 0